import { Injectable } from '@angular/core';
import { LanguageService } from '@spartacus/core';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CurrentLanguageSelected {
  currentLanguage = 'en';

  constructor(private languageService: LanguageService) {
    languageService
      .getActive()
      .pipe(take(1))
      .subscribe((lang) => {
        this.currentLanguage = lang;
      });
  }

  getCurrentLanguage() {
    return this.currentLanguage;
  }
}
